import React, { Component } from 'react'
import logo from './assets/img/logo.svg'
import logovc from './assets/img/logo-vc.svg'
import { Link } from 'react-router-dom'

class Header extends Component {

  state = {
    affix: ''
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  
  componentWillUnmount(){
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = (e) => {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      this.setState({affix:'affix'})

  } else {
    this.setState({affix:''})
  }
  }

  render() {
    return (
      <header>
      <div className={`nav-bar ${this.state.affix}`}>
        <div className="logo-menu">
          <div className="logo">
          <Link to="/"><span className="summit"><img src={logo} alt="hack.summit()" height="26" width="212"/></span></Link>
          </div>
          <svg width="21px" height="30px" viewBox="0 0 51 50" version="1.1" xmlns="http://www.w3.org/2000/svg" className="plus">
            <g stroke="none" strokeWidth="1" fillRule="evenodd" fill="#8A8B87">
              <path d="M25.033,0 C11.226,0 0.033,11.19 0.033,25 C0.033,38.81 11.226,50 25.033,50 C38.841,50 50.033,38.81 50.033,25 C50.033,11.19 38.841,0 25.033,0 L25.033,0 Z M25.033,1.6 C37.936,1.6 48.434,12.1 48.434,25 C48.434,37.9 37.936,48.4 25.033,48.4 C12.131,48.4 1.633,37.9 1.633,25 C1.633,12.1 12.131,1.6 25.033,1.6 L25.033,1.6 Z"></path>
              <path d="M26.033,24 L26.033,10 L24.033,10 L24.033,24 L10.033,24 L10.033,26 L24.033,26 L24.033,40 L26.033,40 L26.033,26 L40.033,26 L40.033,24 L26.033,24 Z"></path>
            </g>
          </svg>
          <div className="pane">
          <a href="https://www.hack-vc.com" className="hackvc"><img src={logovc} alt="hack.vc()" target="_blank" height="26" width="212"/></a>
          </div>
        </div>
      </div>
    </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js